import { render, staticRenderFns } from "./DishRankingGlobal.vue?vue&type=template&id=0416ec9c&scoped=true&lang=pug"
import script from "./DishRankingGlobal.vue?vue&type=script&lang=js"
export * from "./DishRankingGlobal.vue?vue&type=script&lang=js"
import style0 from "./DishRankingGlobal.vue?vue&type=style&index=0&id=0416ec9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416ec9c",
  null
  
)

export default component.exports